import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { FinancialEntityBranchFailure, FinancialEntityBranchRequest, FinancialEntityBranchSuccess } from './actions';
import { FinancialEntityBranchService } from './service';

('./actions');
('./service');

@Injectable()
export class FinancialEntityBranchEffects {
  private readonly actions$ = inject(Actions);
  private readonly financialEntityBranchService = inject(FinancialEntityBranchService);

  financialEntityBranch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FinancialEntityBranchRequest),
      switchMap(({ parameters }) =>
        this.financialEntityBranchService.financialEntityBranch(parameters).pipe(
          map(data => FinancialEntityBranchSuccess({ data })),
          catchError(error => of(FinancialEntityBranchFailure({ error })))
        )
      )
    )
  );

}
